import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RecPlanSearchService } from '../../rec-plan-search-service';
import { RecPlanDocImageComponent } from '../../components/rec-plan-doc-image/rec-plan-doc-image.component';
import { Location } from '@angular/common';
import { NavMenuService } from '../../../shared/services/nav-menu-service';

@Component({
  selector: 'app-rec-plan-name-doc-disp-pg',
  providers: [RecPlanSearchService],
  templateUrl: './rec-plan-name-doc-disp-pg.component.html',
  styleUrls: ['./rec-plan-name-doc-disp-pg.component.css']
})
export class RecPlanNameDocDispPgComponent implements OnInit {
  public planID: string;
  public book: string;
  public page: string;
  public bookType: string;

  collapsesideinfo: boolean = false;
  //public record: RecDocVM;
  error: any;
  public isImgVwVisible: boolean = true;
  public isLoadingDetail: boolean = true;
  @ViewChild(RecPlanDocImageComponent, { static: false }) recPlanDocImageComponent;
  screenWidth: any;


  constructor(private route: ActivatedRoute, private router: Router, private location: Location, private nav: NavMenuService) {
    this.book = this.route.snapshot.paramMap.get('book');
    //console.log('book: ' + this.book);
    this.page = this.route.snapshot.paramMap.get('page');
    //console.log('page: ' + this.page);
    this.planID = this.route.snapshot.paramMap.get('bookType');
    //console.log('bookType: ' + this.bookType);
    this.isLoadingDetail = true;
  }

  ngOnInit(): void {
    //throw new Error("Method not implemented.");
  }

  back(url) {

    var prev = document.referrer;
    console.log('ID = ' + this.planID);
    console.log(prev);
    if (prev.indexOf('rec-plan-bp-search') > 0 || prev.indexOf('rec-plan-name') > 0 || prev.indexOf('rec-name-result') > 0 )  {
      window.opener = 'Self';
      window.open('', '_parent', '');
      window.close();
    }
    else {
      this.location.back();
    }
    ////this.router.navigate([url]);
    //window.opener = 'Self';
    //window.open('', '_parent', '');
    //window.close();

  }


  toggleSideInfo() {
    this.collapsesideinfo = !this.collapsesideinfo;

  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenWidth = window.innerWidth;
  }

  getIsImgVwVisible(e) {
    this.isImgVwVisible = e;
  }

 

}
